export default "__VITE_ASSET__B6D2QFHj__"